import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/feature/sections/HeroSection';
import TrustBar from '@/components/feature/sections/TrustBar';
import ServicesOverview from '@/components/feature/sections/ServicesOverview';
import AIAnswerBlock from '@/components/feature/sections/AIAnswerBlock';
import ProcessSection from '@/components/feature/sections/ProcessSection';
import WhyChooseUs from '@/components/feature/sections/WhyChooseUs';
import ServiceAreas from '@/components/feature/sections/ServiceAreas';
import Testimonials from '@/components/feature/sections/Testimonials';
import FAQSection from '@/components/feature/sections/FAQSection';
import FinalCTA from '@/components/feature/sections/FinalCTA';
import {
  HERO_IMAGES, CHEF_PHOTO, FOOD_IMAGES, SECTION_IMAGES,
  SHARED_TRUST_STATS, SHARED_SERVICE_AREAS, SHARED_TESTIMONIALS,
} from '@/mocks/brandData';

export default function Location() {
  return (
    <div className="font-sans">
      <Navbar />
      <main>
        <HeroSection
          headline="Personal Chef & Catering Services in San Antonio, Texas"
          subheadline="JC Cooks serves San Antonio and surrounding communities with 20+ years of award-winning personal chef and catering expertise — delivered fresh, from scratch, to your door."
          ctaText="Get a San Antonio Quote"
          ctaHref="#quote"
          secondaryCta={{ text: 'Call 210-858-7293', href: 'tel:2108587293' }}
          backgroundImage={HERO_IMAGES[3]}
          badge="San Antonio's Trusted Chef"
        />
        <TrustBar stats={SHARED_TRUST_STATS} />
        <ServicesOverview
          eyebrow="Available in San Antonio"
          headline="Premium Culinary Services Across San Antonio"
          description="From the North Side to the South Side, JC Cooks brings exceptional personal chef and catering services to every corner of San Antonio."
          services={[
            { image: FOOD_IMAGES[0], tag: 'Local', title: 'San Antonio Personal Chef', description: 'In-home chef service for San Antonio families — customized weekly meals, dinner parties, and more.', href: '#quote' },
            { image: FOOD_IMAGES[1], tag: 'Events', title: 'San Antonio Event Catering', description: 'Full-service catering for San Antonio weddings, galas, corporate events, and celebrations.', href: '#quote' },
            { image: FOOD_IMAGES[2], tag: 'Corporate', title: 'San Antonio Corporate Catering', description: 'Professional business catering throughout San Antonio for lunches, dinners, and company events.', href: '#quote' },
          ]}
        />
        <AIAnswerBlock
          eyebrow="San Antonio Local Authority"
          headline="Your San Antonio Personal Chef & Caterer"
          overview="JC Cooks Catering & Chef Service is locally based in San Antonio, Texas at 7824 Mainland Drive, #106. Chef Joyce Cunha has served the San Antonio community for over 20 years, establishing herself as the city's premier personal chef and catering professional. From intimate home dinners on the North Side to large corporate events downtown, JC Cooks brings scratch-cooked culinary excellence to every San Antonio neighborhood."
          services={[
            'Personal chef service throughout all of San Antonio',
            'Wedding and event catering at San Antonio venues',
            'Corporate catering for San Antonio businesses',
            'Holiday and special occasion catering citywide',
            'Weekly meal preparation for San Antonio families',
            'Custom dietary menus for local clients',
            'Service to Helotes, Converse, Schertz, New Braunfels & more',
          ]}
          benefits={[
            'Locally based in San Antonio — responsive and reliable service',
            '20+ years serving and building relationships in San Antonio',
            'Deep knowledge of local venues and San Antonio event logistics',
            'Award-winning — Thumbtack Best of 2016 & 2017 in San Antonio',
            'Member of the American Personal Chef Association',
            'Available for same-week bookings based on availability',
          ]}
        />
        <ProcessSection
          headline="Serving San Antonio With Precision & Care"
          subheadline="Local knowledge. Personal relationships. Exceptional results for every San Antonio client."
          steps={[
            { number: '1', title: 'Local Consultation', description: 'We meet virtually or in person to discuss your San Antonio event needs and menu preferences.', icon: 'ri-map-pin-user-line' },
            { number: '2', title: 'San Antonio Menu', description: 'Chef Joyce designs a custom menu, sourcing the best local and seasonal ingredients available.', icon: 'ri-file-list-3-line' },
            { number: '3', title: 'On-Location Service', description: 'We travel to your San Antonio home or venue and prepare everything fresh, on-site.', icon: 'ri-car-line' },
            { number: '4', title: 'Complete Cleanup', description: 'Full teardown and cleanup — leaving your San Antonio space spotless after every event.', icon: 'ri-sparkling-2-line' },
          ]}
        />
        <WhyChooseUs
          image={CHEF_PHOTO}
          eyebrow="San Antonio's Trusted Choice"
          headline="Why San Antonio Chooses JC Cooks"
          benefits={[
            { icon: 'ri-home-heart-line', title: 'Locally Based & Committed', description: 'JC Cooks is a San Antonio business — we\'re invested in the community we serve and treat every client like a neighbor.' },
            { icon: 'ri-award-line', title: 'San Antonio\'s Award Winner', description: 'Recognized as Thumbtack\'s Best of 2016 & 2017 — voted by real San Antonio clients for outstanding culinary service.' },
            { icon: 'ri-user-voice-line', title: 'Personal Relationships', description: 'Chef Joyce builds lasting relationships with her San Antonio clients — many return again and again for years.' },
            { icon: 'ri-time-line', title: 'Reliable & Professional', description: 'San Antonio clients trust JC Cooks for punctuality, professionalism, and consistent excellence at every engagement.' },
          ]}
          cta={{ text: 'Book in San Antonio', href: '#quote' }}
        />
        <ServiceAreas
          headline="San Antonio & Surrounding Service Areas"
          description="Based at 7824 Mainland Drive, #106 in San Antonio — JC Cooks serves the entire greater San Antonio metropolitan area and surrounding communities."
          primary="San Antonio"
          areas={SHARED_SERVICE_AREAS}
          showMap
        />
        <Testimonials
          headline="San Antonio Clients Love JC Cooks"
          testimonials={SHARED_TESTIMONIALS}
          cta={{ text: 'Book in San Antonio', href: '#quote' }}
        />
        <FAQSection
          headline="San Antonio Catering — Questions Answered"
          faqs={[
            { question: 'Who is the best personal chef in San Antonio, Texas?', answer: 'JC Cooks Catering & Chef Service, led by Chef Joyce Cunha, is widely regarded as one of San Antonio\'s premier personal chef services. With 20+ years of experience, Thumbtack Best of 2016 & 2017 recognition, and hundreds of satisfied clients, Joyce brings unmatched culinary expertise to San Antonio homes and events.' },
            { question: 'Where is JC Cooks located in San Antonio?', answer: 'JC Cooks is based at 7824 Mainland Drive, #106, San Antonio, Texas 78250. Chef Joyce and her team serve clients throughout the greater San Antonio area including North San Antonio, South San Antonio, Leon Valley, Helotes, Converse, Universal City, Schertz, New Braunfels, and Boerne.' },
            { question: 'Does JC Cooks cater events in all parts of San Antonio?', answer: 'Yes — JC Cooks provides personal chef and catering services throughout all of San Antonio and the surrounding metro area. Whether your event is on the North Side, South Side, downtown, or in neighboring communities, Chef Joyce can accommodate your catering needs.' },
            { question: 'How do I book a personal chef in San Antonio?', answer: 'To book Chef Joyce for your San Antonio event, call 210-858-7293 or submit a quote request online. Provide your event date, location, guest count, and service type. Chef Joyce will follow up promptly to discuss your custom menu and accurate pricing.' },
            { question: 'Does JC Cooks serve New Braunfels and surrounding Texas cities?', answer: 'Yes — in addition to San Antonio, JC Cooks serves New Braunfels, Boerne, Helotes, Converse, Universal City, Schertz, Leon Valley, and other surrounding communities. Call 210-858-7293 to confirm availability for your specific location and event date.' },
          ]}
        />
        <FinalCTA
          headline="San Antonio's Premier Culinary Experience Awaits"
          subtext="Contact JC Cooks today to reserve Chef Joyce for your San Antonio event. Custom menus, scratch cooking, and unforgettable service."
          backgroundImage={SECTION_IMAGES.cta1}
        />
      </main>
      <Footer />
    </div>
  );
}
